import {Injectable} from "@angular/core";
import {Apollo} from "apollo-angular";
import { HttpHeaders } from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {catchError, map} from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})

export class GraphqlService {

  options: { mutation: any; variables?: any; apolloNamespace?: string; } | undefined;

  constructor(
    private apollo: Apollo,
  ) {
  }

  async query(
    options: {
      query: any,
      variables?: any,
      apolloNamespace?: string
    },
    fetchPolicy: any = 'network-only',
    context: any = {headers: new HttpHeaders().set('ngLoader', 'false')},
    errorPolicy: any = 'all'
  ): Promise<any> {
    // Set default namespace and check if environment is activated to enable namespace usage
    let segment = 'default';
    return firstValueFrom(this.apollo.use(segment).query({
      query: options.query,
      variables: options.variables,
      fetchPolicy,
      context,
      errorPolicy,
    }));
  }

  queryObservable(
    options: {
      query: any,
      variables?: any,
      apolloNamespace?: string
    },
    fetchPolicy: any = 'network-only',
    errorPolicy: any = 'all'
  ) {
    // Set default namespace and check if environment is activated to enable namespace usage
    let segment = 'default';
    return this.apollo.use(segment).query({
      query: options.query,
      variables: options.variables,
      fetchPolicy,
      errorPolicy,
    });
  }

  async mutate(
    options: {
      mutation: any,
      variables?: any,
      apolloNamespace?: string,
      doNotReportError?: boolean,
      context?: object,
    },
  ): Promise<any> {
    this.options = options;
    return firstValueFrom(this.mutateObservable({
      ...options
    }));
  }

  mutateObservable(options: {
    mutation: any,
    variables?: any,
    apolloNamespace?: string,
    doNotReportError?: boolean,
    context?: any
  }) {
    // Set default namespace and check if environment is activated to enable namespace usage
    let segment = 'default';
    return this.apollo.use(segment)
      .mutate(options).pipe(map((response: any) => {
        if (response.errors && response.data == null) {
          const errorText = response?.errors?.message || response?.errors[0]?.message;
          throw new Error(errorText);
        }
        return response;
      }), catchError((e) => {
        // const errorText = e.message;
        if (!options.doNotReportError) {
          // this.reportErrorFromGraph(errorMetadata);
        }
        throw new Error(e);
      }));
  }

}
